import {
  colors,
  spacing,
  fontSizes,
  fonts,
} from "@softmax/design-system/tokens.stylex";
import type {
  SiteFooterLinkItem,
  SiteFooterLinkRenderer,
} from "./site-footer-types";
import * as stylex from "@stylexjs/stylex";
import { styles } from "./site-footer.styles";
import { externalLinkProps, ExternalMark } from "../external-mark";

export function FooterLink({
  link,
  renderLink,
}: {
  readonly link: SiteFooterLinkItem;
  readonly renderLink: SiteFooterLinkRenderer;
}) {
  const children = (
    <>
      {link.label}
      {link.note ? (
        <>
          {" "}
          <span {...stylex.props(localStyles.note)}>{link.note}</span>
        </>
      ) : null}
    </>
  );
  const linkStyle = stylex.props(localStyles.link, styles.linkStates);

  if (link.external) {
    return (
      <a href={link.href} {...externalLinkProps} {...linkStyle}>
        {children}
        <ExternalMark />
      </a>
    );
  }

  return renderLink({ href: link.href, ...linkStyle, children });
}

const localStyles = stylex.create({
  link: {
    display: "block",
    fontFamily: fonts.mono,
    fontSize: fontSizes.label,
    lineHeight: "normal",
    fontWeight: 400,
    color: colors.inverse,
    textDecoration: "none",
    paddingBlock: { default: 0, "@media (pointer: coarse)": 13 },
    minWidth: { default: 0, "@media (pointer: coarse)": 44 },
  },
  note: {
    marginLeft: spacing.space4,
    fontFamily: fonts.sans,
    fontSize: 12,
    lineHeight: "14px",
    color: colors.inverseMuted,
  },
});
